import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import InvestmentsSimulation from './InvestmentsSimulation';
import { setAccountData } from 'store/features/account/actions';
import { AppDispatch, RootState } from 'store/types';

const mapStateToProps = (state: RootState) => ({
  value: state.account.investment,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({ setAccountData }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentsSimulation);
